<template>
    <div class="nav-height newnavbar" id="navbarstyles">
        <nav class="navbar-default navbar-fixed-top p-lg-2">
          <div class="col d-flex">
            <div class="col-lg-9 col-md-4 col-4 pl-0 pl-md-2 mr-auto mt-3 d-flex">
              <div>
                <img src="../../assets/Logo.svg" alt="logo" class="MainNewLogo pointer" @click="NavToLanding"/>
                </div>
                <!-- <div class="d-none d-lg-block mt-0 ml-lg-4 ml-3 mr-3">
                    <li class="nav-item dropdown mt-2">
                        <span class="nav-link navtoPage" href="#" data-toggle="dropdown">
                            <span class="font16-bold pointer">Products</span>
                            <img src="../../assets/arrowdown.svg" class="ml-2" alt="arrow">
                        </span>
                        <ul class="dropdown-menu">
                            <li>
                              <span class="dropdown-item" href="#" @click="NavToBusinessAccount">
                                <img src="../../assets/BusinessAccountpop.svg" class="imd-fluid mr-1" />
                                <span class="fontsize14 proximanova-semibold black margintop1">User Professional</span>
                              </span>
                            </li>
                            <li>
                              <span class="dropdown-item mt-1" href="#" @click="NavToPostAjob"> 
                                <img src="../../assets/BusinessAccountpop.svg" class="imd-fluid mr-1" />
                                <span class="fontsize14 proximanova-semibold black margintop1">Business</span>
                              </span>
                            </li>
                        </ul>
                    </li>
                </div> -->
                <div class="d-none d-lg-block mt-0 ml-lg-5 ml-3 mr-3 p-2 navtoPage">
                  <span class="font16-bold pointer text-nowrap" @click="NavToUserAccount">For Professional</span>
                </div>
                <div class="d-none d-lg-block mt-0 ml-lg-4 ml-3 mr-3 p-2 navtoPage">
                  <span class="font16-bold pointer text-nowrap" @click="NavToBusinessAccount">For Business</span>
                </div>
                <!-- <div class="d-none d-lg-block mt-0 ml-lg-4 ml-3 mr-3 p-2 navtoPage">
                  <span class="font16-bold pointer text-nowrap" :class="{'active':  currentRoute === 'LandingPage'}" @click="NavToPostAjob">Recruiter</span>
                </div> -->
            </div>
            <div class=" mt-3 p-2 mr-2 mr-md-4 navtoPage pointer">
              <span @click="NavToSignIn">
                <img src="../../assets/Sign In.svg" alt="signin" class="img-fluid" /> <span class="font16-bold ml-2">Sign In</span>
              </span>
            </div>
            <div class="d-none d-md-block mt-3 mr-md-3">
              <span class="btn button-create mouseoverbtn2 backgroundcolorblack borderradius20 white" @click="NavToSignup">
                  <img src="../../assets/Sign_up.svg" class="img-fluid negmar1" alt="signup"/> 
                  <span class="proximanova ml-1">Create free account</span> 
              </span>
            </div>
            <button class="navbar-toggler d-block d-lg-none mr-2 mr-md-3 mt-2" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <img src="../../assets/HamburgrMenu.svg" class="img-fluid hamburgericon" alt="hamburger">
            </button>
            <div class="collapse navbar-collapse collapsableNav" id="navbarCollapse">
              <div class="d-flex justify-content-between p-2 pb-3 mt-3 borderbottom">
                <img src="../../assets/Logo.svg" class="MainNewLogo img-fluid pointer col-6 pl-0 pr-0" alt="logo" @click="NavToLanding"/>
                <img src="../../assets/Hamburger_Back.svg" class="img-fluid col-2 pl-0 pointer" alt="back" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation"/>
              </div>
              <ul class="navbar-nav p-2 mt-3">
                <li class="nav-item">
                  <span class="link my-auto proximanova fontsize14 black" @click="NavToLanding">Home</span>
                </li>
                <li class="nav-item">
                  <span class="link my-auto proximanova fontsize14 black" @click="NavToUserAccount">For Professional</span>
                </li>
                <li class="nav-item">
                  <span class="link my-auto proximanova fontsize14 black" @click="NavToBusinessAccount">For Business</span>
                </li>
                <!-- <li class="nav-item mt-2">
                  <div data-target="#demo1" class=" d-flex mt-1 justify-content-between" data-toggle="collapse" aria-haspopup="true" aria-expanded="false">
                      <span class="link my-auto proximanova fontsize14 black">Products</span>
                      <img src="../../assets/arrowdown.svg" class="ml-2" alt="arrow">
                  </div>
                  <div id="demo1" class="collapse ml-1 pl-2 mt-2">
                      <li>
                        <span class="" @click="NavToUserAccount">
                          <img src="../../assets/BusinessAccountpop.svg" alt="user" class="imd-fluid mr-1" />
                          <span class="fontsize12 proximanova black margintop1" :class="{'active':  currentRoute === 'UserLandingPage'}">For Professional</span>
                        </span>
                      </li>
                      <li>
                        <span class="" @click="NavToBusinessAccount">
                          <img src="../../assets/BusinessAccountpop.svg" alt="business" class="imd-fluid mr-1" />
                          <span class="fontsize12 proximanova black margintop1">For Business</span>
                        </span>
                      </li>
                      <li class="mt-1">
                        <span @click="NavToPostAjob"> 
                          <img src="../../assets/PostaJobpop.svg" alt="postjob" class="imd-fluid mr-1" />
                          <span class="fontsize12 proximanova black margintop1" :class="{'active':  currentRoute === 'LandingPage'}">Recruiter</span>
                        </span>
                      </li>
                  </div>
                </li> -->
                <span class="borderbottom mt-2"></span>
                <li class="nav-item mt-2">
                  <span class="link my-auto proximanova fontsize14 black" @click="NavToSignIn">Login</span>
                </li>
                <li class="nav-item mt-3">
                  <span class="btn button-create backgroundcolorblack white" @click="NavToSignup">
                    <img src="../../assets/Sign_up.svg" class="img-fluid negmar1" alt="signup"/> 
                    <span class="proximanova ml-1">Create free account</span> 
                </span>
                </li>
              </ul>
	          </div>
          </div>          
        </nav>
      </div>
</template>
<script>
import router from '../../router.js'
import wndata from '../../js/wn_data.json'
import $ from 'jquery'
export default {
  data() {
    return {
      currentRoute : null,
    };
  },
  methods: {
    setNavStyles() {
            var myNav = document.getElementById("navbarstyles");
            window.onscroll = function() {
            if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
                myNav.classList.add("backgroundcolorwhite");
            } else {
                myNav.classList.remove("backgroundcolorwhite");
            }
            }
      },
    fetchdata() {
      this.currentRoute = this.$router.currentRoute.name;
        $(document).on('click', '.dropdown-menu', function (e) {
        e.stopPropagation();
        });
        if ($(window).width() < 992) {
        $('.dropdown-menu a').click(function(e){
            if($(this).attr('href') == '#')
            e.preventDefault();
            if($(this).next('.submenu').length){
            $(this).next('.submenu').toggle();
            }
            $('.dropdown').on('hide.bs.dropdown', function () {
            $(this).find('.submenu').hide();
            })
        });
        }
    },
    NavToUserAccount(){
      var x = document.createElement('a')
      // x.target = '_blank'
      x.href = wndata.userWebapp;
      x.click()
    },
    NavToBusinessAccount() {
      var x = document.createElement('a')
      // x.target = '_blank'
      x.href = wndata.companyAccountWebapp;
      x.click()
    },
    NavToPostAjob(){
      this.scorlltop()
      router.push({
          name : 'LandingPage'
      })
    },
    NavToSignup() {
      this.clearDataFromLocalstorage()
      router.push({
        name : 'signup'
      })
    },
    NavToSignIn() {
      this.clearDataFromLocalstorage()
      router.push({
        name : 'signin'
      })
    },
    NavToLanding(){
      this.clearDataFromLocalstorage()
        // router.push({
        //     name : 'LandingPage'
        // })
        var x = document.createElement('a')
      // x.target = '_blank'
      x.href = wndata.worknotionApp;
      x.click()
    },
    clearDataFromLocalstorage() {
      localStorage.removeItem("selectedPlan")
      localStorage.removeItem("selectedPlanCard")
      localStorage.removeItem("billingCountry")
    },
    scorlltop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
  mounted: function() {
    window.scrollTo(0, 0)
    this.setNavStyles()
    this.fetchdata();
  }
};
</script>
<style scoped>
.navtoPage {
  transition : ease-out 0.3s;
	POSITION : relative;
	/* z-index : 1; */
  padding-left : 5px;
  padding-right: 5px;
  padding-top: 1px;
}
.active{
  /* border: 2px solid #007AFF;  
  background-color: #d6e9ff  !important; */
  background-color: rgba(161, 166, 179,0.06);
  border-bottom: 2px solid #007AFF;
   color: #007AFF !important;
   cursor: pointer;
}
.navtoPage::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.navtoPage:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
@media (min-width: 992px){
  .dropdown-menu .dropdown-toggle:after {
    border-top: .3em solid transparent;
    border-right: 0;
    border-bottom: .3em solid transparent;
    border-left: .3em solid;
  }
  .dropdown-menu .dropdown-menu{
    margin-left:0; margin-right: 0;
  }
  .dropdown-menu{
      border-radius: 10px !important;
  }
  .dropdown-menu li{
    position: relative;
  }
  .dropdown-item{
      cursor: pointer;
      padding: .25rem 1.5rem .25rem 1rem;
      border-left: 2px solid white;
  }
  .dropdown-item:hover {
    border-left: 3px solid #007AFF;
  }
  .nav-item{
      list-style-type: none;
  }
  .nav-item .submenu{ 
    display: none;
    position: absolute;
    left:100%; top:-7px;
  }
  .nav-item .submenu-left{ 
    right:100%; left:auto;
  }
  .dropdown-menu > li:hover{ background-color: #f1f1f1 }
  .dropdown-menu > li:hover > .submenu{
    display: block;
  }
}
@media (max-width: 500px) {
  .navbar-collapse {
    width: 75% !important;
  }
  .navbar-collapse.collapsing {
    left: -75% !important;
    transition: height 0s ease;
  }
  .hamburgericon{
    width: 25px;
  }
}
@media (max-width: 992px) {
  .navbar-collapse {
    position: fixed;
    left: 0;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
    width: 50%;
    height: 100%;
    float: right;
  }
  .navbar-collapse.collapsing {
    left: -50%;
    transition: height 0s ease;
  }
  .navbar-collapse.show {
    left: 0;
    transition: left 300ms ease-in-out;
  }
  .navbar-toggler.collapsed ~ .navbar-collapse {
    transition: left 500ms ease-in-out;
  }
}
.newnavbar{
    position: fixed;
    width: 100%;
    /* background-color: white; */
    background: transparent;
    z-index: 5;
    height: 85px !important;
}
.negmar1{
  margin-top: -4px;
}
.collapsableNav{
  z-index: 4 !important;
  background-color: white;
  box-shadow: 0 10px 15px rgba(33,33,33,.2);
}
#demo1{
  border-left: 1px solid #DDDFE5;
}
</style>